/**
 * @typedef { 'shown' | 'pressed' | 'scrolled' } EventType
 */

/**
 * Event type enum for analytics tracking.
 * @readonly
 * @enum {string}
 */
export const EVENT_TYPE = Object.freeze({
  /**
   * Represents an event when an element is shown to the user.
   * @type {string}
   */
  SHOWN: 'show',

  /**
   * Represents an event when a press action occurs, such as clicking an anchor or button.
   * @type {string}
   */
  PRESSED: 'pressed',

  /**
   * Represents an event when the user scrolls through a page or element.
   * @type {string}
   */
  SCROLLED: 'scrolled',
})
